import React from 'react';
import { SvgProps } from 'apps/sigma2-ui/src/components/svg/types';
import { toSvgColor } from 'apps/sigma2-ui/src/components/svg/types';

export const AIMagicIconGroup: React.FC<SvgProps> = (props) => {
  const strokeColor = toSvgColor('currentColor', props);

  return (
    <g {...(props.group ?? {})}>
      <path
        d="M14.398 0.71875L18.1072 10.7426L28.131 14.4517L18.1072 18.1609L14.398 28.1847L10.6889 18.1609L0.665039 14.4517L10.6889 10.7426L14.398 0.71875Z"
        fill={strokeColor}
      />
      <path
        d="M32.2461 17.2812L34.4068 23.1205L40.2461 25.2812L34.4068 27.442L32.2461 33.2812L30.0854 27.442L24.2461 25.2812L30.0854 23.1205L32.2461 17.2812Z"
        fill={strokeColor}
      />
    </g>
  );
};

export const AIMagicIconSvg: React.FC<SvgProps> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="41"
      height="34"
      viewBox="0 0 41 34"
      fill="none"
      {...(props.svg ?? {})}
    >
      <AIMagicIconGroup {...props} />
    </svg>
  );
};
